<template>
  <v-toolbar-items>
    <v-btn flat @click="$router.push('/admin/users')">Users</v-btn>
    <v-btn flat @click="$router.push('/admin/instaplays')">Instaplays</v-btn>

    <user-menu></user-menu>
  </v-toolbar-items>
</template>

<script>
    import UserMenu from "@/components/UserMenu";
    export default {
        name: "AdminNavBar",
        components: {UserMenu}
    }
</script>

<style scoped>

</style>
